export default __webpack_public_path__ + "static/thin-cup-light-green-a5b659a2b6a3d7c7fa7989561eb272e0.png";